import React from 'react';
import PropTypes from 'prop-types';
import { ArrowForward } from '@mui/icons-material';
import OldMultipleCTA from './Versions/old/ArticleMultipleChoiceCTA';
import NewMultipleCTA from './Versions/new/ArticleMultipleChoiceCTA';

const ArticleMultipleChoiceCTA = ({
    buttonLabel,
    buttonIcon = <ArrowForward />,
    buttonAttributes = { target: '_blank' },
    className = '',
    title = null,
    articleId = '',
    variant = 'old',
}) => 
{
    const handleVariant = () => 
    {
        if (variant === 'new') 
        {
            return <NewMultipleCTA className={className} title={title} articleId={articleId} />;
        }
        return (
            <OldMultipleCTA
                buttonLabel={buttonLabel}
                buttonIcon={buttonIcon}
                buttonAttributes={buttonAttributes}
                className={className}
                title={title}
                articleId={articleId}
            />
        );
    };
    return handleVariant();
};
ArticleMultipleChoiceCTA.propTypes = {
    /** Label of the button */
    buttonLabel: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.node,
        PropTypes.array,
    ]).isRequired,
    /** Icon for the button */
    buttonIcon: PropTypes.object,
    /** Additional attributes for the button, e.g. target="_blank", rel="nofollow" */
    buttonAttributes: PropTypes.object,
    /** CSS classes */
    className: PropTypes.string,
    /** Title of the article multiple choice CTA */
    title: PropTypes.string,
    /** Article Identifier */
    articleId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    /** Variant of the component */
    variant: PropTypes.oneOf(['old', 'new']),
};

export default ArticleMultipleChoiceCTA;
